import { Component, inject, effect } from '@angular/core';
import { LayoutComponent } from '@core/layout/layout.component';
import { ConfigService } from '@core/config/config.service';
import { SavedItemsService } from './services/saved-items.service';
import { AuthService } from '@core/auth/auth.service';

@Component({
  selector: 'app-root',
  imports: [LayoutComponent],
  templateUrl: './app.html',
})
export class App {
  constructor() {
    inject(ConfigService).load();
    const auth = inject(AuthService);
    const savedItems = inject(SavedItemsService);
    effect(() => {
      if (auth.isLoggedIn()) {
        savedItems.loadSavedIds();
      }
    });
  }
}
